import _trim from 'lodash/trim';

export const getSearchResultsURL = (slug?: string | string[]) => {
  const baseUrl = '/inspiration/real-weddings';

  if (slug) {
    if (Array.isArray(slug) && slug.length > 0) {
      return `${baseUrl}/${slug.join('--')}`;
    }

    if (typeof slug === 'string' && _trim(slug).length > 0) {
      return `${baseUrl}/${slug}`;
    }
  }

  return '/inspiration';
};
